import { render } from "./PayBills.vue?vue&type=template&id=2c643439&scoped=true"
import script from "./PayBills.vue?vue&type=script&lang=js"
export * from "./PayBills.vue?vue&type=script&lang=js"

import "./PayBills.vue?vue&type=style&index=0&id=2c643439&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c643439"]])

export default __exports__